import { kea } from 'kea'

import requestLogic from '~/scenes/pages/request/logic'
import searchLogic from '~/scenes/search/logic'

export default kea({
  path: () => ['scenes', 'footer', 'index'],

  connect: {
    props: [requestLogic, ['pageKeyword'], searchLogic, ['isFullScreenFiltersPage', 'isFullScreenMap']]
  },

  dimensions: {
    windowWidth: [typeof window !== 'undefined' && window.innerWidth, window => window.innerWidth]
  }
})
